// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"96c14cf1","453":"006b49e8"}[chunkId] + ".chunk.js";
};